/**
 * Máy nhớ ai vừa đăng nhập, để lần sau chỉ còn gõ **mã 6 số** (khách phản ánh 23/09: "đăng nhập
 * tiệm rất phức tạp" — mỗi lần hết phiên lại phải gõ đủ ba ô).
 *
 * Chỉ nhớ mã tiệm, số điện thoại, tên để chào — **không bao giờ nhớ mã đăng nhập**. Đây là máy của
 * tiệm (tablet quầy / điện thoại của chính nhân viên); ai cầm máy mà không biết mã thì vẫn không vào
 * được, và "Không phải bạn?" xoá ngay những gì máy nhớ.
 */

const KHOA = 'sapa.dangNhap'
/** Khoá cũ (trước 23/09) chỉ nhớ mã tiệm — từ 27/09 không cần nữa (đăng nhập bằng số), chỉ còn xoá. */
const KHOA_CU = 'sapa.maTiem'

export interface DaNho {
  tiem: string
  sdt: string
  ten: string
  tenTiem?: string
}

function laDaNho(x: unknown): x is DaNho {
  if (typeof x !== 'object' || x === null) return false
  const o = x as Record<string, unknown>
  return typeof o.tiem === 'string' && typeof o.sdt === 'string' && typeof o.ten === 'string'
}

export function docNho(): DaNho | null {
  try {
    const raw = localStorage.getItem(KHOA)
    if (raw === null) return null
    const v: unknown = JSON.parse(raw)
    return laDaNho(v) && v.tiem !== '' && v.sdt !== '' ? v : null
  } catch {
    return null
  }
}

export function ghiNho(v: DaNho): void {
  try {
    localStorage.setItem(KHOA, JSON.stringify(v))
    localStorage.removeItem(KHOA_CU)
  } catch {
    // Không nhớ được thì lần sau gõ lại. Không phải lỗi.
  }
}

/**
 * Bổ sung / cập nhật tên tiệm (biết sau `/auth/toi`) vào đúng người đang nhớ. Máy nhớ id tiệm (từ 27/09)
 * hoặc slug (máy cũ) — khớp cái nào cũng được; khớp slug thì đổi sang nhớ id.
 */
export function nhoTenTiem(tiem: { id: string; ma: string }, tenTiem: string): void {
  const nho = docNho()
  if (nho === null || (nho.tiem !== tiem.id && nho.tiem !== tiem.ma) || tenTiem === '') return
  if (nho.tiem === tiem.id && nho.tenTiem === tenTiem) return
  ghiNho({ ...nho, tiem: tiem.id, tenTiem })
}

/**
 * Đổi số đăng nhập của CHÍNH MÌNH xong (v0.22.3 B4): máy phải nhớ số MỚI, nếu không lần hết phiên sau màn đăng nhập điền số cũ và
 * người dùng tưởng bị khoá. Chưa nhớ gì thì không nhớ thêm (không tự dựng bản nhớ từ chỗ khác).
 */
export function capNhatSoNho(nho: DaNho | null, soMoi: string): DaNho | null {
  return nho === null ? null : { ...nho, sdt: soMoi }
}

/** `capNhatSoNho` áp lên bản nhớ của máy này (nếu có). */
export function nhoSoMoi(soMoi: string): void {
  const moi = capNhatSoNho(docNho(), soMoi)
  if (moi !== null) ghiNho(moi)
}

export function quenNho(): void {
  try {
    localStorage.removeItem(KHOA)
  } catch {
    // Không xoá được thì thôi.
  }
}

/**
 * Người dùng gõ mã tiệm theo đủ kiểu: "Anstar Hair Salon", "anstar hair salon ", dán cả đường dẫn
 * `https://sapa.autopostvn.com/?tiem=anstar-hair-salon`. Đưa hết về dạng máy chủ nhận (`a-z0-9-`).
 */
export function chuanHoaMaTiem(nhap: string): string {
  let s = nhap.trim()
  const trongLink = /[?&]tiem=([^&#\s]+)/i.exec(s)
  if (trongLink?.[1] !== undefined) {
    try {
      s = decodeURIComponent(trongLink[1])
    } catch {
      s = trongLink[1]
    }
  }
  return s
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/đ/g, 'd')
    .replace(/Đ/g, 'D')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
}
